/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { CycleCountBinPoolDtoListBaseResponse } from '../models/cycle-count-bin-pool-dto-list-base-response';
import { CycleCountDto } from '../models/cycle-count-dto';
import { CycleCountDtoBaseResponse } from '../models/cycle-count-dto-base-response';
import { CycleCountItemDtoListBaseResponse } from '../models/cycle-count-item-dto-list-base-response';
import { CycleCountListDtoPagedResponseBaseResponse } from '../models/cycle-count-list-dto-paged-response-base-response';
import { CycleCountScheduleDto } from '../models/cycle-count-schedule-dto';
import { CycleCountScheduleDtoBaseResponse } from '../models/cycle-count-schedule-dto-base-response';
import { CycleCountScheduleDtoListBaseResponse } from '../models/cycle-count-schedule-dto-list-base-response';
import { OrderDirection } from '../models/order-direction';
import { PropertyFilter } from '../models/property-filter';
import { StringBaseResponse } from '../models/string-base-response';

@Injectable({
  providedIn: 'root',
})
export class CycleCountService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiCycleCountPaginatedListGet
   */
  static readonly ApiCycleCountPaginatedListGetPath = '/api/CycleCount/paginated-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountPaginatedListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountPaginatedListGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<CycleCountListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountPaginatedListGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountPaginatedListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountPaginatedListGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<CycleCountListDtoPagedResponseBaseResponse> {

    return this.apiCycleCountPaginatedListGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountListDtoPagedResponseBaseResponse>) => r.body as CycleCountListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountPaginatedListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountPaginatedListGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<CycleCountListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountPaginatedListGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountPaginatedListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountPaginatedListGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<CycleCountListDtoPagedResponseBaseResponse> {

    return this.apiCycleCountPaginatedListGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountListDtoPagedResponseBaseResponse>) => r.body as CycleCountListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountGetCycleCountGet
   */
  static readonly ApiCycleCountGetCycleCountGetPath = '/api/CycleCount/get-cycle-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountGetCycleCountGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGetCycleCountGet$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<CycleCountDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountGetCycleCountGetPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountGetCycleCountGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGetCycleCountGet$Plain(params?: {
    id?: number;
  }): Observable<CycleCountDtoBaseResponse> {

    return this.apiCycleCountGetCycleCountGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountDtoBaseResponse>) => r.body as CycleCountDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountGetCycleCountGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGetCycleCountGet$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<CycleCountDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountGetCycleCountGetPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountGetCycleCountGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGetCycleCountGet$Json(params?: {
    id?: number;
  }): Observable<CycleCountDtoBaseResponse> {

    return this.apiCycleCountGetCycleCountGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountDtoBaseResponse>) => r.body as CycleCountDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountAddCycleCountPost
   */
  static readonly ApiCycleCountAddCycleCountPostPath = '/api/CycleCount/add-cycle-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountAddCycleCountPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountAddCycleCountPost$Plain$Response(params?: {
    body?: CycleCountDto
  }): Observable<StrictHttpResponse<CycleCountDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountAddCycleCountPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountAddCycleCountPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountAddCycleCountPost$Plain(params?: {
    body?: CycleCountDto
  }): Observable<CycleCountDtoBaseResponse> {

    return this.apiCycleCountAddCycleCountPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountDtoBaseResponse>) => r.body as CycleCountDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountAddCycleCountPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountAddCycleCountPost$Json$Response(params?: {
    body?: CycleCountDto
  }): Observable<StrictHttpResponse<CycleCountDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountAddCycleCountPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountAddCycleCountPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountAddCycleCountPost$Json(params?: {
    body?: CycleCountDto
  }): Observable<CycleCountDtoBaseResponse> {

    return this.apiCycleCountAddCycleCountPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountDtoBaseResponse>) => r.body as CycleCountDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountUpdateCycleCountPut
   */
  static readonly ApiCycleCountUpdateCycleCountPutPath = '/api/CycleCount/update-cycle-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountUpdateCycleCountPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountUpdateCycleCountPut$Plain$Response(params?: {
    body?: CycleCountDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountUpdateCycleCountPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountUpdateCycleCountPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountUpdateCycleCountPut$Plain(params?: {
    body?: CycleCountDto
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountUpdateCycleCountPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountUpdateCycleCountPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountUpdateCycleCountPut$Json$Response(params?: {
    body?: CycleCountDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountUpdateCycleCountPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountUpdateCycleCountPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountUpdateCycleCountPut$Json(params?: {
    body?: CycleCountDto
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountUpdateCycleCountPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountToggleArchiveCycleCountPost
   */
  static readonly ApiCycleCountToggleArchiveCycleCountPostPath = '/api/CycleCount/toggle-archive-cycle-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountToggleArchiveCycleCountPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountToggleArchiveCycleCountPost$Plain$Response(params?: {
    cycleCountId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountToggleArchiveCycleCountPostPath, 'post');
    if (params) {
      rb.query('cycleCountId', params.cycleCountId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountToggleArchiveCycleCountPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountToggleArchiveCycleCountPost$Plain(params?: {
    cycleCountId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountToggleArchiveCycleCountPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountToggleArchiveCycleCountPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountToggleArchiveCycleCountPost$Json$Response(params?: {
    cycleCountId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountToggleArchiveCycleCountPostPath, 'post');
    if (params) {
      rb.query('cycleCountId', params.cycleCountId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountToggleArchiveCycleCountPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountToggleArchiveCycleCountPost$Json(params?: {
    cycleCountId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountToggleArchiveCycleCountPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountSchedulesGet
   */
  static readonly ApiCycleCountSchedulesGetPath = '/api/CycleCount/schedules';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountSchedulesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountSchedulesGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<CycleCountScheduleDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountSchedulesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountScheduleDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountSchedulesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountSchedulesGet$Plain(params?: {
  }): Observable<CycleCountScheduleDtoListBaseResponse> {

    return this.apiCycleCountSchedulesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountScheduleDtoListBaseResponse>) => r.body as CycleCountScheduleDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountSchedulesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountSchedulesGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<CycleCountScheduleDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountSchedulesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountScheduleDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountSchedulesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountSchedulesGet$Json(params?: {
  }): Observable<CycleCountScheduleDtoListBaseResponse> {

    return this.apiCycleCountSchedulesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountScheduleDtoListBaseResponse>) => r.body as CycleCountScheduleDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountAddSchedulePost
   */
  static readonly ApiCycleCountAddSchedulePostPath = '/api/CycleCount/add-schedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountAddSchedulePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountAddSchedulePost$Plain$Response(params?: {
    body?: CycleCountScheduleDto
  }): Observable<StrictHttpResponse<CycleCountScheduleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountAddSchedulePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountScheduleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountAddSchedulePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountAddSchedulePost$Plain(params?: {
    body?: CycleCountScheduleDto
  }): Observable<CycleCountScheduleDtoBaseResponse> {

    return this.apiCycleCountAddSchedulePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountScheduleDtoBaseResponse>) => r.body as CycleCountScheduleDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountAddSchedulePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountAddSchedulePost$Json$Response(params?: {
    body?: CycleCountScheduleDto
  }): Observable<StrictHttpResponse<CycleCountScheduleDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountAddSchedulePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountScheduleDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountAddSchedulePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountAddSchedulePost$Json(params?: {
    body?: CycleCountScheduleDto
  }): Observable<CycleCountScheduleDtoBaseResponse> {

    return this.apiCycleCountAddSchedulePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountScheduleDtoBaseResponse>) => r.body as CycleCountScheduleDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountUpdateSchedulePut
   */
  static readonly ApiCycleCountUpdateSchedulePutPath = '/api/CycleCount/update-schedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountUpdateSchedulePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountUpdateSchedulePut$Plain$Response(params?: {
    body?: CycleCountScheduleDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountUpdateSchedulePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountUpdateSchedulePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountUpdateSchedulePut$Plain(params?: {
    body?: CycleCountScheduleDto
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountUpdateSchedulePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountUpdateSchedulePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountUpdateSchedulePut$Json$Response(params?: {
    body?: CycleCountScheduleDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountUpdateSchedulePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountUpdateSchedulePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountUpdateSchedulePut$Json(params?: {
    body?: CycleCountScheduleDto
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountUpdateSchedulePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountArchiveSchedulePost
   */
  static readonly ApiCycleCountArchiveSchedulePostPath = '/api/CycleCount/archive-schedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountArchiveSchedulePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountArchiveSchedulePost$Plain$Response(params?: {
    cycleCountScheduleId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountArchiveSchedulePostPath, 'post');
    if (params) {
      rb.query('cycleCountScheduleId', params.cycleCountScheduleId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountArchiveSchedulePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountArchiveSchedulePost$Plain(params?: {
    cycleCountScheduleId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountArchiveSchedulePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountArchiveSchedulePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountArchiveSchedulePost$Json$Response(params?: {
    cycleCountScheduleId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountArchiveSchedulePostPath, 'post');
    if (params) {
      rb.query('cycleCountScheduleId', params.cycleCountScheduleId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountArchiveSchedulePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountArchiveSchedulePost$Json(params?: {
    cycleCountScheduleId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountArchiveSchedulePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountGenerateRandomBinsPost
   */
  static readonly ApiCycleCountGenerateRandomBinsPostPath = '/api/CycleCount/generate-random-bins';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountGenerateRandomBinsPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGenerateRandomBinsPost$Plain$Response(params?: {
    cycleCountId?: number;
    binCount?: number;
  }): Observable<StrictHttpResponse<CycleCountBinPoolDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountGenerateRandomBinsPostPath, 'post');
    if (params) {
      rb.query('cycleCountId', params.cycleCountId, {});
      rb.query('binCount', params.binCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountBinPoolDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountGenerateRandomBinsPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGenerateRandomBinsPost$Plain(params?: {
    cycleCountId?: number;
    binCount?: number;
  }): Observable<CycleCountBinPoolDtoListBaseResponse> {

    return this.apiCycleCountGenerateRandomBinsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountBinPoolDtoListBaseResponse>) => r.body as CycleCountBinPoolDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountGenerateRandomBinsPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGenerateRandomBinsPost$Json$Response(params?: {
    cycleCountId?: number;
    binCount?: number;
  }): Observable<StrictHttpResponse<CycleCountBinPoolDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountGenerateRandomBinsPostPath, 'post');
    if (params) {
      rb.query('cycleCountId', params.cycleCountId, {});
      rb.query('binCount', params.binCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountBinPoolDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountGenerateRandomBinsPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGenerateRandomBinsPost$Json(params?: {
    cycleCountId?: number;
    binCount?: number;
  }): Observable<CycleCountBinPoolDtoListBaseResponse> {

    return this.apiCycleCountGenerateRandomBinsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountBinPoolDtoListBaseResponse>) => r.body as CycleCountBinPoolDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountMarkBinScannedPost
   */
  static readonly ApiCycleCountMarkBinScannedPostPath = '/api/CycleCount/mark-bin-scanned';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountMarkBinScannedPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountMarkBinScannedPost$Plain$Response(params?: {
    cycleCountBinPoolId?: number;
    userId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountMarkBinScannedPostPath, 'post');
    if (params) {
      rb.query('cycleCountBinPoolId', params.cycleCountBinPoolId, {});
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountMarkBinScannedPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountMarkBinScannedPost$Plain(params?: {
    cycleCountBinPoolId?: number;
    userId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountMarkBinScannedPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountMarkBinScannedPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountMarkBinScannedPost$Json$Response(params?: {
    cycleCountBinPoolId?: number;
    userId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountMarkBinScannedPostPath, 'post');
    if (params) {
      rb.query('cycleCountBinPoolId', params.cycleCountBinPoolId, {});
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountMarkBinScannedPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountMarkBinScannedPost$Json(params?: {
    cycleCountBinPoolId?: number;
    userId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountMarkBinScannedPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountCompleteCycleCountPost
   */
  static readonly ApiCycleCountCompleteCycleCountPostPath = '/api/CycleCount/complete-cycle-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountCompleteCycleCountPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountCompleteCycleCountPost$Plain$Response(params?: {
    cycleCountId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountCompleteCycleCountPostPath, 'post');
    if (params) {
      rb.query('cycleCountId', params.cycleCountId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountCompleteCycleCountPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountCompleteCycleCountPost$Plain(params?: {
    cycleCountId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountCompleteCycleCountPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountCompleteCycleCountPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountCompleteCycleCountPost$Json$Response(params?: {
    cycleCountId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountCompleteCycleCountPostPath, 'post');
    if (params) {
      rb.query('cycleCountId', params.cycleCountId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountCompleteCycleCountPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountCompleteCycleCountPost$Json(params?: {
    cycleCountId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountCompleteCycleCountPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountApproveVariancePost
   */
  static readonly ApiCycleCountApproveVariancePostPath = '/api/CycleCount/approve-variance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountApproveVariancePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountApproveVariancePost$Plain$Response(params?: {
    cycleCountItemId?: number;
    approved?: boolean;
    approverUserId?: number;
    notes?: string;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountApproveVariancePostPath, 'post');
    if (params) {
      rb.query('cycleCountItemId', params.cycleCountItemId, {});
      rb.query('approved', params.approved, {});
      rb.query('approverUserId', params.approverUserId, {});
      rb.query('notes', params.notes, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountApproveVariancePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountApproveVariancePost$Plain(params?: {
    cycleCountItemId?: number;
    approved?: boolean;
    approverUserId?: number;
    notes?: string;
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountApproveVariancePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountApproveVariancePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountApproveVariancePost$Json$Response(params?: {
    cycleCountItemId?: number;
    approved?: boolean;
    approverUserId?: number;
    notes?: string;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountApproveVariancePostPath, 'post');
    if (params) {
      rb.query('cycleCountItemId', params.cycleCountItemId, {});
      rb.query('approved', params.approved, {});
      rb.query('approverUserId', params.approverUserId, {});
      rb.query('notes', params.notes, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountApproveVariancePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountApproveVariancePost$Json(params?: {
    cycleCountItemId?: number;
    approved?: boolean;
    approverUserId?: number;
    notes?: string;
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountApproveVariancePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountPendingApprovalsGet
   */
  static readonly ApiCycleCountPendingApprovalsGetPath = '/api/CycleCount/pending-approvals';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountPendingApprovalsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountPendingApprovalsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<CycleCountItemDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountPendingApprovalsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountItemDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountPendingApprovalsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountPendingApprovalsGet$Plain(params?: {
  }): Observable<CycleCountItemDtoListBaseResponse> {

    return this.apiCycleCountPendingApprovalsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountItemDtoListBaseResponse>) => r.body as CycleCountItemDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountPendingApprovalsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountPendingApprovalsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<CycleCountItemDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountPendingApprovalsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CycleCountItemDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountPendingApprovalsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountPendingApprovalsGet$Json(params?: {
  }): Observable<CycleCountItemDtoListBaseResponse> {

    return this.apiCycleCountPendingApprovalsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CycleCountItemDtoListBaseResponse>) => r.body as CycleCountItemDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountGetCcRefPost
   */
  static readonly ApiCycleCountGetCcRefPostPath = '/api/CycleCount/get-cc-ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountGetCcRefPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountGetCcRefPost$Plain$Response(params?: {
    body?: CycleCountDto
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountGetCcRefPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountGetCcRefPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountGetCcRefPost$Plain(params?: {
    body?: CycleCountDto
  }): Observable<StringBaseResponse> {

    return this.apiCycleCountGetCcRefPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountGetCcRefPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountGetCcRefPost$Json$Response(params?: {
    body?: CycleCountDto
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountGetCcRefPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountGetCcRefPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCycleCountGetCcRefPost$Json(params?: {
    body?: CycleCountDto
  }): Observable<StringBaseResponse> {

    return this.apiCycleCountGetCcRefPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountGetNextCcRefGet
   */
  static readonly ApiCycleCountGetNextCcRefGetPath = '/api/CycleCount/get-next-cc-ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountGetNextCcRefGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGetNextCcRefGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountGetNextCcRefGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountGetNextCcRefGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGetNextCcRefGet$Plain(params?: {
  }): Observable<StringBaseResponse> {

    return this.apiCycleCountGetNextCcRefGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountGetNextCcRefGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGetNextCcRefGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountGetNextCcRefGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountGetNextCcRefGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountGetNextCcRefGet$Json(params?: {
  }): Observable<StringBaseResponse> {

    return this.apiCycleCountGetNextCcRefGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * Path part for operation apiCycleCountTriggerRemindersPost
   */
  static readonly ApiCycleCountTriggerRemindersPostPath = '/api/CycleCount/trigger-reminders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountTriggerRemindersPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountTriggerRemindersPost$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountTriggerRemindersPostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountTriggerRemindersPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountTriggerRemindersPost$Plain(params?: {
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountTriggerRemindersPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCycleCountTriggerRemindersPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountTriggerRemindersPost$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CycleCountService.ApiCycleCountTriggerRemindersPostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCycleCountTriggerRemindersPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCycleCountTriggerRemindersPost$Json(params?: {
  }): Observable<BooleanBaseResponse> {

    return this.apiCycleCountTriggerRemindersPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
